export default __webpack_public_path__ + "static/media/Levitate D2.4 Intermediate exploitation plan.ec9376bb.pdf";